export default __webpack_public_path__ + "static/media/lbs-graph-revert.4a9ee513.png";